import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
    selector: 'app-mm-multiluck-modal',
    templateUrl: './mm-multiluck-modal.component.html',
    styleUrls: ['./mm-multiluck-modal.component.scss'],
})
export class MmMultiluckModalComponent implements OnInit {

    @Input() statusMultiluck: boolean = false;
    @Input() productName: string;
    @Input() image: string;

    constructor(private modalCtrl: ModalController) { }

    ngOnInit() { }

    touchDismiss() {
        this.modalCtrl.dismiss();
    }

}
